import React from "react";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import GridContainer from "../../../components/Grid/GridContainer";
import CustomDate from "../../../components/CustomDate/CustomDate";
import moment from "moment";
import GridItem from "../../../components/Grid/GridItem";
import CustomInput from "../../../components/CustomInput/CustomInputValidate";
import { clone } from "../../../shared/utility";

export const isBeforeLeaseStart = (dateStr, data) => {
  if (!data?.lease_start_date) return false;
  const date_to_go_by = data.lease_ranges_based_off === "Rent Commencement Date" ? 
        data.rent_commencement 
    :
        data.lease_start_date;
  if (data.lease_ranges_based_off === "Rent Commencement Date" && !data?.rent_commencement) {
    return false;
  }
  const inputDate = moment(dateStr, 'MM/DD/YYYY', true);
  const leaseStart = moment(date_to_go_by, 'MM/DD/YYYY', true);

  // Ensure both are valid
  if (!inputDate.isValid() || !leaseStart.isValid()) return false;

  return inputDate.isBefore(leaseStart, 'day');
}

const PreLeaseForm = props => {
    const { 
        data, 
        setData, 
        
    } = props;

    const handleChange = event => {
        setData({
        ...data,
        pre_lease_term_abated_rent: event.target.checked
        });
    };
    if (!data.lease_start_date) {
        if (data.lease_start_date_estimated_tbd || data.occupancy_date_estimated_tbd || data.rent_commencement_estimated_tbd) {
            return <div className="boxed" style={{marginTop:20}}>
                    <GridContainer>
                        <GridItem xs={12} sm={3} md={3}>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={!!data.pre_lease_term_abated_rent}
                                            onChange={handleChange}
                                            color="primary"
                                            style={{ filter: 'grayscale(100%)' }}
                                        />
                                    }
                                    label="Pre-Rent Term Abated Rent"
                                />
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={3} md={3}>
                            <div style={{opacity: data.pre_lease_term_abated_rent ? 1 : 0}}>
                                <CustomInput
                                    label="Months"
                                    value={data.pre_lease_term_abated_rent_months}
                                    isRequired={true}
                                    onChange={(e) => {
                                        const newData = clone(data);
                                        newData.pre_lease_term_abated_rent_months = e.target.value;
                                        setData(newData);
                                    }}
                                />
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={3} md={3}>
                            <div style={{opacity: data.pre_lease_term_abated_rent ? 1 : 0}}>
                                <CustomInput
                                    label="Days"
                                    value={data.pre_lease_term_abated_rent_days}
                                    isRequired={true}
                                    onChange={(e) => {
                                        const newData = clone(data);
                                        newData.pre_lease_term_abated_rent_days = e.target.value;
                                        setData(newData);
                                    }}
                                />
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={3} md={3}>
                            <div style={{opacity: data.pre_lease_term_abated_rent ? 1 : 0}}>
                                <CustomInput
                                    label="Commission Rate"
                                    value={data.pre_lease_term_abated_rent_commission_value}
                                    isRequired={true}
                                    onChange={(e) => {
                                        const newData = clone(data);
                                        newData.pre_lease_term_abated_rent_commission_value = e.target.value;
                                        setData(newData);
                                    }}
                                    // isCurrency={true}
                                    endAdornment="%"
                                />
                            </div>
                        </GridItem>
                    </GridContainer>
            </div>
        }
        return null;
    }

    return <div className="boxed" style={{marginTop:20}}>
    <GridContainer>
        <GridItem xs={12} sm={3} md={3}>
            <div>
                <FormControlLabel
                    control={
                        <Switch
                            checked={!!data.pre_lease_term_abated_rent}
                            onChange={handleChange}
                            color="primary"
                            style={{ filter: 'grayscale(100%)' }}
                        />
                    }
                    label="Pre-Rent Term Abated Rent"
                />
            </div>
        </GridItem>
        <GridItem xs={12} sm={3} md={3}>
            <div style={{opacity: data.pre_lease_term_abated_rent ? 1 : 0}}>
                <CustomDate
                    label="Pre-Rent Start Date"
                    value={data.pre_lease_term_abated_rent_start_date}
                    condition={(start_date) => {
                        return isBeforeLeaseStart(start_date, data)
                    }}
                    onChange={(newDate) => {
                        setData({
                        ...data,
                        pre_lease_term_abated_rent_start_date: newDate
                        });
                    }}
                />
            </div>
        </GridItem>
        <GridItem xs={12} sm={3} md={3}>
            <div style={{opacity: data.pre_lease_term_abated_rent ? 1 : 0}}>
                <CustomDate 
                    label="Pre-Rent End Date"
                    value={data.pre_lease_term_abated_rent_end_date}
                    condition={(end_date) => {
                        return isBeforeLeaseStart(end_date, data)
                    }}
                    onChange={(newDate) => {
                        setData({
                        ...data,
                        pre_lease_term_abated_rent_end_date: newDate
                        });
                    }}
                />
            </div>
        </GridItem>
        <GridItem xs={12} sm={3} md={3}>
            <div style={{opacity: data.pre_lease_term_abated_rent ? 1 : 0}}>
                <CustomInput
                    label="Commission Rate"
                    value={data.pre_lease_term_abated_rent_commission_value}
                    isRequired={true}
                    onChange={(e) => {
                        const newData = clone(data);
                        newData.pre_lease_term_abated_rent_commission_value = e.target.value;
                        setData(newData);
                    }}
                    // isCurrency={true}
                    endAdornment="%"
                />
            </div>
        </GridItem>
    </GridContainer>
    <GridContainer>
        <GridItem xs={12} sm={12} md={12}></GridItem>
    </GridContainer>
    </div>
}

export default PreLeaseForm;